import React from 'react'

const faqData = [
  {
    showOnSteps: ['1'],
    questionKey: 'family-review.faq.question0',
    questionDefault: 'What is a record?',
    answerKey: 'family-review.faq.answer0',
    answerDefault:
      'A record is a document that certifies a life event. It can be as large as a few images or as small as a line or two on a ledger or register.',
    learnMoreLink:
      'https://www.familysearch.org/help/helpcenter/article/what-is-the-difference-between-a-record-and-an-image',
  },
  {
    showOnSteps: ['1'],
    questionKey: 'family-review.faq.question1',
    questionDefault: 'What if there is just part of a name selected?',
    answerKey: 'family-review.faq.answer1',
    answerDefault:
      'If the part of the name you see belongs to the primary person in the record, go ahead and mark “Yes.” You can change highlights in a later step.',
  },
  {
    showOnSteps: ['1'],
    questionKey: 'family-review.faq.question2',
    questionDefault: 'What if the primary person is right but the name is misspelled?',
    answerKey: 'family-review.faq.answer2',
    answerDefault: 'Go ahead and select “Yes.” You will have a chance to change spellings in a later step.',
  },
  {
    showOnSteps: ['2'],
    questionKey: 'family-review.faq.primary-person-question',
    questionDefault: 'Who is a primary person?',
    answerKey: 'family-review.faq.primary-person-answer',
    answerDefault:
      'The primary person is the name of the person at the center of the event. Most historical records contain just one primary name.',
    learnMoreLink:
      'https://www.familysearch.org/help/helpcenter/article/who-is-the-principal-person-in-a-historical-record',
  },
  {
    showOnSteps: ['2'],
    questionKey: 'family-review.faq.missing-person-question',
    questionDefault: 'What if someone is missing in this transcription?',
    answerKey: 'family-review.faq.missing-person-answer',
    answerDefault: 'Scroll down to the bottom and click Add New Person.',
  },
  {
    showOnSteps: ['3'],
    questionKey: 'family-review.faq.question4',
    questionDefault: 'What is an event?',
    answerKey: 'family-review.faq.answer4',
    answerDefault: (
      <>
        The primary event is the event the record certifies. This could be a census, a baptism, a marriage, etc.
        Inferred events are other events mentioned in the document. For example, in a census, you might find information
        about where a person was born or lived.
      </>
    ),
  },
  {
    showOnSteps: ['3'],
    questionKey: 'family-review.faq.question5',
    questionDefault: 'What if I want to add an event?',
    answerKey: 'family-review.faq.answer5',
    answerDefault: 'Scroll down to the bottom and click Add Event.',
  },
  {
    showOnSteps: ['1', '1-2', '2', '3'],
    questionKey: 'family-review.faq.question3',
    questionDefault: 'What should I do if I see a problem with this record?',
    answerKey: 'family-review.faq.answer3',
    answerDefault:
      'If you want to correct the problem, go to the Record Details page, click edit, and make the correction.',
  },
]

export default faqData
